import http from "@/request/index.ts";

export default class NewsApi {
  /**
   * 获取新闻接口
   */
  async getNewsList(data) {
    let res = await http.get("/news/list", data);
    return res;
  }

  /**
   * 获取新闻详情接口
   */
  async getNewsDetail(id) {
    let res = await http.get("/news/" + id);
    return res.data
  }

  /**
   * 新闻浏览量增加
   */
  async addNewsBrowse(id) {
    let res = await http.post("/news/readNum/" + id);
    return res.data
  }
}
